import {BaseContainerModel} from '../../base-container.model';
import {bl_hr_claim_account_entitlement_approval_setting_RowClass} from '../../../dbschema';

export class HrClaimApprovalSettingContainerModel extends BaseContainerModel {
  bl_hr_claim_account_entitlement_approval_setting: bl_hr_claim_account_entitlement_approval_setting_RowClass = new bl_hr_claim_account_entitlement_approval_setting_RowClass();
}
